module.exports = __webpack_public_path__ + "static/img/150019.ef155974.png";